import React, { useState } from 'react';
import { Tabs, Card } from 'antd';
import { DatabaseOutlined, FileOutlined, TeamOutlined } from '@ant-design/icons';
import { StorageDashboard } from '../components/storage/StorageDashboard';
import { FileFilters } from '../components/storage/FileFilters';
import { FileListTable } from '../components/storage/FileListTable';
import { OrganizationStorageView } from '../components/storage/OrganizationStorageView';
import { useFileFilters } from '../hooks/useFileList';
import { PageHeader, PageContainer, DevFilePathBadge } from '../components/common';

/**
 * ストレージ管理メインページ
 */
export function StorageManagementPage() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const { filters, resetFilters, setFilters } = useFileFilters();

  return (
    <PageContainer>
      <DevFilePathBadge filePath="client/src/pages/StorageManagement.tsx" />
      <PageHeader
        title="ストレージ容量管理"
        subtitle="ファイルの容量管理とアーカイブ設定を行います"
      />

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          {
            key: 'dashboard',
            label: (
              <span>
                <DatabaseOutlined />
                ダッシュボード
              </span>
            ),
            children: <StorageDashboard />,
          },
          {
            key: 'files',
            label: (
              <span>
                <FileOutlined />
                ファイル一覧
              </span>
            ),
            children: (
              <div>
                <FileFilters
                  filters={filters}
                  onFilterChange={setFilters}
                  onReset={resetFilters}
                />
                <Card>
                  <FileListTable filters={filters} />
                </Card>
              </div>
            ),
          },
          {
            key: 'organization',
            label: (
              <span>
                <TeamOutlined />
                組織別使用量
              </span>
            ),
            children: <OrganizationStorageView />,
          },
        ]}
      />
    </PageContainer>
  );
}
